import { Component, Input, OnInit, inject } from '@angular/core';
import { User } from 'BaseDataTypes';
import {
  Customer,
  Project,
  RequisitionNumber,
  RequisitionStatus,
  RequisitionStatusTranslations,
  RequisitionTaskStatus,
  RequisitionTaskStatusTranslations,
} from 'TimelogDataTypes';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { dialogData, genericDialogComponent } from '../genericDialog';
import { RequisitionNumberService } from 'TimelogServices/requisition-number-service';
import { ProjectService } from 'TimelogServices/project-service';
import { CustomerService } from 'TimelogServices/customer-service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from 'BaseServices/user-service';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';

@Component({
    selector: 'app-requsition-number-dialog',
    imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent
],
    templateUrl: './requsition-number-dialog.component.html',
    styleUrls: [
        '../../../../../../src/app/general-styles/dialogs.css',
        './requsition-number-dialog.component.css',
    ],
    providers: [DatePipe]
})
export class RequsitionNumberDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<RequisitionNumber[]>>(MAT_DIALOG_DATA);
  @Input() requsitionNumber!: RequisitionNumber;
  projects: Project[] = [];
  filteretProjects: Project[] = [];
  customers: Customer[] = [];
  users: User[] = [];
  selectedCustomer: number = 0;
  currentUser = this.userService.currentUser;
  dialogInputTitleComponent = dialogInputTitleComponent;

  requisitionStatus = Object.values(RequisitionStatus);
  requisitionTaskStatus = Object.values(RequisitionTaskStatus);
  requisitionStatusTranslations = RequisitionStatusTranslations;
  requisitionTaskStatusTranslations = RequisitionTaskStatusTranslations;
  constructor(
    public override dialogRef: MatDialogRef<RequsitionNumberDialogComponent>,
    private requisitionNumberService: RequisitionNumberService,
    private projectService: ProjectService,
    private customerService: CustomerService,
    public userService: UserService,
    private datePipe: DatePipe
  ) {
    super(dialogRef);
    this.requsitionNumber = this.data.data[0];

    if (this.requsitionNumber.project != null) {
      this.selectedCustomer = this.requsitionNumber.project.customer.id;
    }
  }

  /**
   * get function for date input, to have date in correct format
   */
  get reqDate() {
    let formattedDate = this.datePipe.transform(
      this.requsitionNumber.date,
      'yyyy-MM-dd'
    )!;
    return formattedDate;
  }
  /**
   * set function for date input, to have date in correct format
   */
  set reqDate(value: string) {
    this.requsitionNumber.date = new Date(value);
  }

  ngOnInit(): void {
    this.projectService.getProjects().subscribe((result) => {
      this.projects = result;
      this.filteretProjects = this.projects;
    });

    this.customerService.getCustomers().subscribe((result) => {
      this.customers = result;
    });

    this.userService.getUsers().subscribe((result) => {
      this.users = result;
    });
  }

  /**
   * Idea is til filter projects based on selected customer, but function is not called right now.
   */
  updateProjectList() {
    if (this.selectedCustomer != 0) {
      this.filteretProjects = this.projects.filter(
        (project) => project.customerId == this.selectedCustomer
      );
    } else {
      this.filteretProjects = this.projects;
    }
    if ((this.requsitionNumber.projectId = 0)) {
      this.requsitionNumber.projectId = this.filteretProjects[0].id;
    }
  }

  /**
   * Update customer based on what project is chosen
   */
  updateCustomer() {
    if (this.requsitionNumber.projectId != 0) {
      this.selectedCustomer = this.getCustomerId(
        this.requsitionNumber.projectId
      );
    }
  }

  //function to get customerId based on projectId
  getCustomerId(projectId: number) {
    let project = this.projects.find((project) => project.id == projectId);
    if (project != null) {
      return project.customerId;
    }
    return 0;
  }

  /**
   * Saves changes to the requisitionNumber, by calling updateRequisitionNumber service.
   */
  saveChanges() {
    this.requisitionNumberService
      .upsertRequisitionNumber(this.requsitionNumber)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }

  /**
   *  Deletes a requisitionNumber by calling deleteRequisitionNumber service.
   */
  deleteRequisitionNumber() {
    if (
      !confirm(
        "Er du sikker på at du vil slette rekvisitionsnummeret '" +
        this.requsitionNumber.reqNumber + "'?"
      )
    ) {
      return;
    }
    this.requisitionNumberService
      .deleteRequisitionNumber(this.requsitionNumber.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
